import { render, staticRenderFns } from "./FeriadoList.vue?vue&type=template&id=a875740c"
import script from "./FeriadoList.vue?vue&type=script&lang=js"
export * from "./FeriadoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports